import React, { useState } from "react";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import "../vehicle/vehicle.css"
import VehicleImg from "../../../assets/imgs/no data found.jpg"
import { Image } from "primereact/image";

const NoVehicleFound = () => {
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const history = useHistory();

    const status = [
        { status: "checked" },
        { status: "pending" },
    ]
    return (
        <>
            <div className=''>
                <div className='flex justify-content-center align-items-center p-8'>
                    <div className="">
                        <div className="col-12 xl:col-12 lg:col-12">
                            <div className="">
                                <div className="flex flex-column align-items-center">
                                    <Image src={VehicleImg} width={300} />
                                    <h4 className="text-black-alpha-70 text-2xl text-center m-1">No vehicles added yet. Please add a vehicle to get started!</h4>
                                </div>

                                <div className="col-12 xl:col-12 lg:col-12">
                                    <div className="flex justify-content-center ">
                                        <Button onClick={() => history.push('/add-vehicle')} className="font-medium mt-3 text-lg w-9rem">Add Vehicle</Button>
                                    </div>
                                </div>

                            </div>
                            {/* <div className="flex justify-content-between items-center">

                                <div className="" style={{ width: "3rem", height: "3rem" }}>
                                    <i className="pi pi-car text-primary" style={{ fontSize: '2rem' }}></i>
                                </div>


                                <div>
                                    <Button
                                        type="button"
                                        className="p-button p-button-danger"
                                        onClick={() => console.log('Delete clicked')}
                                    >
                                        <i className="pi pi-trash"></i>
                                    </Button>
                                </div>
                            </div>


                            <div className="flex justify-content-between mt-2">
                                <h5 className="text-lg text-primary">
                                    Registration Number: ABC-123
                                </h5>
                            </div>
                            <div className="flex justify-content-between mt-2">
                                <h5 className="text-lg text-primary">
                                    Honda
                                </h5>
                            </div>


                            <div className="flex justify-content-between mt-2">
                                <p className="text-md text-primary">
                                    Model: Audi Q8 / Year: 2017
                                </p>
                            </div>


                            <div className="flex justify-content-between mt-4">
                                <div>
                                    <Button
                                        type="button"
                                        className={`p-button p-button-${status.status === 'checked' ? 'success' : 'warning'} p-button-rounded`}
                                    >
                                        {status.status === 'checked' ? (
                                            <i className="pi pi-check"></i>
                                        ) : (
                                            <i className="pi pi-exclamation-circle"></i>
                                        )}
                                        <span className="ml-2">
                                            {status.status === 'checked' ? 'Checked' : 'Pending'}
                                        </span>
                                    </Button>
                                </div>
                            </div> */}

                        </div>
                    </div>

                </div>
            </div>
            {/* <div className="card-section">

                <div className="grid" style={{border:"1px solid blue"}}>
                    <div className="col-4 flex flex-column justify-content-center align-items-center">

                        <>
                            <Image src={VehicleImg} width={100}/>
                            <h3 className="">Page not found</h3>
                        </>

                          <div className="col-12 md:col-12">
                             <div className="button_class-modal">
                                 <Button onClick={[]} icon="pi pi-arrow-left" type="submit" label="Go to home" className="p-button-success btn__default_modal p-button-rounded" />
                             </div>
                         </div> 
                    </div>
                </div>
            </div> */}

        </>
    )
}

export default NoVehicleFound